/* eslint-disable jsx-a11y/anchor-is-valid */
import {KTableProvider} from '../../../../../contexts/KTableProvider'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {useHoteleria} from '../../../../../hooks/useHoteleria'
import {
  TablePersonWrapper,
  TablePendingCheckinWrapper,
  TablePendingCheckoutWrapper,
  TableUploadGuestWrapper,
} from '../component'
const TableBookingIntegrationWrapper = () => {
  const {isAllowed} = useHoteleria()
  return (
    <KTableProvider>
      <div className='sdx_content_tab_panel'>
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Listado de Personas</Tab>
            <Tab className={'sdx_sub_tab_panel_option'}>Checkin Pendientes</Tab>
            <Tab className={'sdx_sub_tab_panel_option'}>Checkout Pendientes</Tab>
            <Tab className={'sdx_sub_tab_panel_option'}>Personas no Cargadas</Tab>
          </TabList>
          <TabPanel>
            <TablePersonWrapper />
          </TabPanel>
          <TabPanel>
            <TablePendingCheckinWrapper />
          </TabPanel>
          <TabPanel>
            <TablePendingCheckoutWrapper />
          </TabPanel>
          <TabPanel>
            <TableUploadGuestWrapper />
          </TabPanel>
        </Tabs>
      </div>
    </KTableProvider>
  )
}

export {TableBookingIntegrationWrapper}
